import { ReactElement } from 'react';

import { NotFoundPage } from '../../../../common/components/pages/NotFoundPage';
import DashboardsFeature from '../molecules/Dashboards';

export default function CommercialPage(): ReactElement {
  return <DashboardsFeature fallback={<NotFoundPage />} />;
}
